import { PHONE_NUMBER } from '@/constants/Common'

const event = {
  events: 'Events',
  eventsNearMe: 'Events Near Me',
  myEvents: 'My Events',
  explore: 'Explore',
  eventStatus: 'Event Status',
  addABracket: 'Add a Bracket',
  editEvent: 'Edit Event',
  endEvent: 'End Event',
  addAnAnnouncement: 'Add An Announcement',
  submitPayment: 'Submit Payment',
  register: 'Register',
  registrationClosed: 'Registration Closed',
  registered: 'Registered',
  aboutTheEvent: 'About The Event',
  announcements: 'Announcements',
  noMoreAnnouncements: 'No more announcements.',
  eventRegistration: 'Event Registration',
  clubMembership: 'Club membership',
  clubMembershipQuestion: 'Are you a member of the host club?',
  contactDetails: 'Contact Details',
  selectYourBrackets: 'Select your Brackets',
  competitionDates: 'Competition Dates',
  invitedPlayer: 'Invited Player',
  invitedPlayerTooltip:
    'You were already invited to this by your partner for this event. To accept or decline this invitation, please go to the "my brackets" section of your player dashboard.',
  ineligibleBracket: 'Ineligible Bracket',
  registrationFull: 'Registration Full',
  registerForWaitlist: 'Register for Waitlist',
  totalPaymentDue: 'Total Payment Due (1 Event)',
  inviteSent: 'Invite Sent',
  offers: 'Offers',
  eventPolicies: 'Event Policies',
  iAgreeText: 'I have read and agree to the',
  healthAndSafetyPolicy: 'Health and Safety Policy',
  liabilityPolicy: 'Liability Policy',
  registeredSuccessfully: 'You have already paid and registered successfully.',
  registrationComplete: 'Registration Complete',
  registrationCompleteText:
    'Your registration is complete. You may edit your registration details from your bracket home page, accessible through the dashboard.',
  continueToPayment: 'Continue to Payment',
  addPhoneNumber: 'Add Phone Number',
  editPhoneNumber: 'Edit Phone Number',
  bracketDetails: 'Bracket Details',
  players: 'Players',
  teams: 'Teams',
  matches: 'Matches',
  partnerConfirmed: 'Partner confirmed',
  noPartnerSelected: 'No partner Selected',
  partnerPending: 'Partner Pending',
  viewDraws: 'View Draws',
  seedMatches: 'Seed Matches',
  editBracket: 'Edit Bracket',
  endBracket: 'End Bracket',
  endBracketModalTitle: "Are you sure that you'd like to end this bracket?",
  endBracketModalDesc:
    'You will no longer be able to make changes to this bracket once you choose to mark it as completed.',
  withdraw: 'Withdraw',
  editPartner: 'Edit Partner',
  removePartner: 'Remove Partner',
  removePartnerFirstDesc: 'Are you sure you would like to decline',
  removePartnerSendDesc: 'invite to play in this event?',
  addPartner: 'Add Partner',
  reopenBracket: 'Reopen Bracket',
  reopenBracketDesc:
    "Once you reopen this bracket, you'll be able to add scores and edit information until the bracket end date.",
  confirmWithdrawFromBracket: 'Are you sure you want to withdraw from this bracket?',
  contactTheEventOrganizer: 'If you plan to request a refund, contact the event organizer before withdrawing.',
  toRegisterFor: 'To register for',
  answerCompleteThePrecess: 'Answer the following details to complete the process.',
  declineInvite: 'Decline invite',
  declineInviteFirstDesc: 'Are you sure you would like to decline',
  declineInviteSecondDesc: 'invite to play in this event?',
  exitTheQueue: 'Exit The Queue',
  exitTheQueueDesc:
    'Exit the queue if you have found a court for your next match. the court must be available, and you must be physically on the court once you choose to exit the queue.',
  WL: 'W/L',
  pointDiff: 'Point Diff',
  waitlisted: 'Waitlisted',
  switchBracket: 'Switch Bracket',
  switchBrackets: 'Switch Brackets',
  switch: 'Switch',
  addParticipant: 'Add Participant',
  switchBracketsConfirmation: 'Are you sure you want to switch brackets for the selected team?',
  withdrawPlayer: 'Withdraw Player',
  confirmWithdrawPlayerFirstText: 'Are you sure you want to remove',
  confirmWithdrawPlayerSecondText: 'from this bracket?',
  withdrawRefund: 'Withdraw/Refund',
  addABracketParticipant: 'Add a Bracket Participant',
  selectAPlayer: 'Select a player from the list below.',
  addABracketParticipantDesc:
    "The accounts that can't be selected are unclaimed/invited. The affected players must register for an account in order to be selected.",
  memberOfHostClub: 'Is Player a member of the host club?',
  selectBracketsToSwitch: 'Select brackets to switch',
  confirmTeam: 'Confirm Team',
  editTeam: 'Edit Team',
  splitTeam: 'Split Team',
  replace: 'Replace',
  addAPartner: 'Add a Partner',
  addAPartnerDesc:
    'If your partner is already a DUPR user you can add them to your team by searching this directory. If your partner is not registered with DUPR, you may invite them to your team via email.',
  teamConfirmed: 'Team Confirmed',
  teamPending: 'Team Pending',
  showUnclaimedAccountsDesc:
    "The accounts that can't be selected are unclaimed/invited. The affected players must register for an account in order to be selected.",
  replaceTeamDesc:
    'You may replace this registered team with any team that is waitlisted for this bracket. Once you make a selection, the matches will get reseeded in source and target brackets automatically. Select from below mentioned teams.',
  confirmEditTeam: 'Are you sure you want to edit team?',
  confirmThisTeams: 'Are you sure you want to confirm this teams?',
  createTeam: 'Create Team',
  playersDifferentGenders: 'Players must be different genders',
  unmatchedTeams: 'Unmatched Teams',
  pleaseSelectAnyTwoPlayers: 'Please select any two players from this list to create a team',
  youSelectedTwoPlayersSameGender:
    'You selected two players of the same gender. Because this is a mixed bracket, all teams must contain one male and one female.',
  thisTeamCannotCreated: 'This team cannot be created because',
  and: 'and',
  isOnTheWaitlist: 'is on the waitlist. Please create a team from non-waitlisted players.',
  afterYouConfirm: 'After you confirm this selection, these players will be moved to the "teams" tab',
  youLikeToCreateTeam: "Are you sure that you'd like to create this team?",
  forfeit: 'Forfeit',
  bye: 'Bye',
  forfeitMatch: 'Forfeit Match',
  forfeitMatchDesc:
    'Please select the team which has forfeited the match. The team that you select will be considered to have lost the match.',
  teamA: 'Team A',
  teamB: 'Team B',
  markAsForfeit: 'Mark As Forfeit',
  youCanAddScores: 'You can add scores between these dates',
  titleSubmitScoreModal: 'Submit Scores for All Games',
  scoreWarningMessage:
    'You must complete the match and submit scores for all games within your match at once. If you plan to submit scores for additional games in this match, go back.',
  editingScoresTitle: 'Editing the scores of a completed event',
  editingScoresFirstDesc:
    'You are editing the scores of a completed event. Standings and future matches of this event will remain unaffected.',
  editingScoresSecondDesc: ' You will loose the integrity of data in Diagram and standings of this event. ',
  stillContinue: 'Do you still want to continue?',
  submitScores: 'Submit Scores',
  submittingScoresTitle: 'Submitting these new scores will affect scheduled matches',
  submittingScoresFirstDesc: 'You chose a new winner, some matches on next round will rescheduled.',
  submittingScoresSecondDesc:
    "If players are already on the court and you do not wish to make edits to the current matchups, click Go Back. You can always edit the scores to induvidual match after the event is completed. If you'd like to proceed with the new matchups, Submit Scores.",
  editScores: 'Edit Scores',
  addScores: 'Add Scores',
  deleteBracketMatchDesc:
    'If you delete this match you will have to start over to enter scores and have it affect your rating.',
  validateMatch: 'Validate Match',
  validateMatchDesc: `Are you sure that you would like to validate these scores? If so, the match will be finalized and player ratings will update. If these scores are not correct, please contact the event director or text ${PHONE_NUMBER} with the correct scores.`,
  validate: 'Validate',
  substitutes: 'Substitutes',
  selectParticipant: 'Select a participant from the list below.',
  totalAmountPaid: 'Total Amount Paid',
  showDetail: 'Show Detail',
  playerStatus: 'Player Status',
  paymentStatus: 'Payment Status',
  amountPaid: 'Amount Paid',
  amountRefunded: 'Amount Refunded',
  bracketName: 'Bracket Name',
  pricing: 'Pricing',
  pricingDesc:
    'Players must pay an event entry fee plus a per bracket fee to compete in an event. Event pricing may also vary depending on whether you are a member of the hosting club.',
  eventEntryFee: 'Event Entry Fee',
  bracketPrice: 'Bracket Price',
  importantDates: 'Important Dates',
  importantDatesDesc:
    'Players must pay an event entry fee plus a per bracket fee to compete in an event. Event pricing may also vary depending on whether you are a member of the hosting club.',
  registrationDates: 'Registration Dates',
  registrationLimit: 'Registration Limit',
  numberTeamsPermitted: 'Number of teams permitted',
  waitlistAllowance: 'Waitlist Allowance',
  allowedWaitlist: 'Teams allowed on the waitlist',
  bracketType: 'Bracket Type',
  roundRobin: 'Round Robin',
  roundRobinDesc:
    'A round-robin tournament is a competition in which each contestant meets all other contestants in turn. A round-robin contrasts with an elimination tournament, in which participants are eliminated after a certain number of losses.',
  waterfall: 'Waterfall',
  waterfallDesc:
    'The 16 team waterfall tournament format ensures that each team plays exactly 4 matches. The bracket is labeled with the 8 directions on a compass(North, South, East, West, Northeast, Northwest, Southeast, and Southwest). For every match, each team plays against a team with the exact same sequence of wins and losses.',
  flexLeague: 'Flex League',
  flexLeagueDesc:
    'DUPR Flex Leagues, similar to round robins, are competitions in which each contestant meets all other contestants in turn. Players organize matches at their leisure, and these events typically take place over extended periods of time.',
  numberCourts: 'Number of Courts',
  playerGroup: 'Player Group',
  playerRules: 'Player Rules',
  skillLevel: 'Skill Level',
  ageGroup: 'Age Group',
  menDoubles: 'Players will compete in teams of two. Each team must be composed of 2 male players.',
  womenDoubles: 'Players will compete in teams of two. Each team must be composed of 2 female players.',
  mixedDoubles: 'Players will compete in teams of two. Each team must be composed of a female and male player.',
  openDoubles: 'Players will compete in teams of two. Players can be any gender combination',
  acceptPartner: 'Accept Partner',
  leagueConsentTitle: 'Your Contact Information Will Be Shared',
  leagueConsentDesc:
    'Once you register for this event, your email and phone number will be visible only to the other players registered for the event. This allows players to contact one another for match scheduling.',
  noQualifyingBrackets: 'No Qualifying Brackets',
  noQualifyingBracketsTitle:
    'You do not qualify for any open brackets within this event based on your DUPR rating, age, and gender profile.',
  pleaseContactEventAdministrator: 'Please contact the event administrator at',
  pleaseContactText: 'if you believe this to be a mistake.',
  step1: 'Step 1: Please select an option and continue',
  refundOnly: 'Refund Only',
  withdrawAndRefund: 'Withdraw and Refund',
  step2: 'Step 2',
  event: 'event',
  bracketsOf: 'brackets of',
  total: 'Total',
  paymentPending: 'Payment Pending',
  freeEvent: 'Free Event',
  fullyRefundedEvent: 'Fully Refunded Event',
  partiallyRefundedEvent: 'Partially Refunded Event',
  fullyRefunded: 'Fully Refunded',
  splitTeamFirst: 'Split Team First',
  freeBracket: 'Free Bracket',
  partiallyRefunded: 'Partially Refunded',
  viewQualifyingPartners: 'View Qualifying Partners',
  viewQualifyingPartnersDesc:
    'This list of DUPR users will only display potential partners that qualify for this bracket based on their stated rating, age, and gender.',
  joiningWaitlist: 'You are Joining a Waitlist',
  joiningWaitlistDesc:
    'You have opted to join the waitlist for at least one of your brackets. You will be notified by the league administration if you are moved off of the waitlist.',
  fromSelectedBrackets: 'from the selected brackets?',
  sureRefundATotalAmount: 'Are you sure you want to refund a total amount of',
  sureRemove: 'Are you sure you want to remove',
  seedMatchesDesc: 'Press Seed Matches to Seed Teams',
  createMatches: 'Create Matches',
  seeds: 'Seeds',
  reseedMatches: 'Reseed Matches',
  bracketCreated: 'Bracket Created.',
  endEventTitleModal: "Are you sure that you'd like to end this event?",
  endEventModalDesc:
    'You will no longer be able to make changes to this event once you chose to mark it as completed. The event will be marked as inactive permanently.',
  moveToUnmatchedTab: `After withdrawing this player, they will be moved to the Unmatched Players tab.
  From there, you can add this player to another team or withdraw them
  from the event altogether.`,
}

export type LocaleEvent = typeof event

export default event
